import { Injectable } from "@angular/core";
import { InspectionImageSchema } from "../../_offline/models/inspectionImage.schema";
import { VegaImageMetadata } from "../../_objects/metadata/vega-image-metadata";
import { Iv7ImageMetadata } from "../../_objects/metadata/iv7-image-metadata";
import { MEASUREMENT_IMAGE_TYPE } from "../../app.constants";
import { SoleilImageMetadata } from "../../_objects/metadata/soleil-image-metadata";
import { BrianImageMetadata } from "../../_objects/metadata/brian-image-metadata";

type InspectionImageMetadata = {zoom: number, isPrintScreen: boolean, adapterName: string | null}

export class MeasurementMetaDataService {

  static getIsMeasurementEnabled(inspectionSchema: InspectionImageSchema): boolean {
    // https://evident-products.atlassian.net/wiki/spaces/Visol/pages/333152280/Measurement+Eligibility
    const defaultZoom = 1;
    const metadata = MeasurementMetaDataService.decodeMetadata(inspectionSchema);
    if (!metadata) return false;

    const { isPrintScreen, zoom, adapterName = "" } = metadata;

    const tipAdapterRegex = /^AT(?:(\d{2}[SD])\/??\1|\d{2,3}(?:SS|DD))/i;
    return (
      !isPrintScreen &&
      zoom === defaultZoom &&
      tipAdapterRegex.test(adapterName)
    );
  }

  static decodeMetadata(schema: InspectionImageSchema): InspectionImageMetadata {
      switch (schema.imageType) {
        case MEASUREMENT_IMAGE_TYPE.VEGA_IMAGE:
          const vegaImageMetadata: VegaImageMetadata = JSON.parse(schema.metadata);
          return {
          adapterName: vegaImageMetadata.opticalAdapter.name,
          isPrintScreen: vegaImageMetadata.image.printScreen == 0 ? false: true,
          zoom: Number(vegaImageMetadata.video.zoom)
          };
        case MEASUREMENT_IMAGE_TYPE.IV7_IMAGE:
          const iv7ImageMetadata: Iv7ImageMetadata = JSON.parse(schema.metadata);
          return {
          adapterName: iv7ImageMetadata.adapterName,
          isPrintScreen: iv7ImageMetadata.screenShot == 0 ? false : true,
          zoom: Number(iv7ImageMetadata.zoomRatio)
          };

        case MEASUREMENT_IMAGE_TYPE.SOLEIL_IMAGE:
          const soleilImageMetadata: SoleilImageMetadata = JSON.parse(schema.metadata);
          return {
            adapterName: soleilImageMetadata.adapterName,
            isPrintScreen: soleilImageMetadata.screenShot == 0 ? false : true,
            zoom: Number(soleilImageMetadata.zoomRatio)
          };
        case MEASUREMENT_IMAGE_TYPE.BRIAN_IMAGE:
          const brianImageMetadata: BrianImageMetadata = JSON.parse(schema.metadata);
          return {
            adapterName: brianImageMetadata.opticalAdapter.name,
            isPrintScreen: brianImageMetadata.image.printScreen == 0 ? false : true,
            zoom: Number(brianImageMetadata.video.zoom)
           };
      }
  }
}
